document.addEventListener('DOMContentLoaded', () => {
  let nextId = 0;
  document.querySelectorAll('.custom-font-select').forEach(container => {
    const trigger = container.querySelector('.selected-font');
    const options = container.querySelector('.font-options');
    if (!trigger || !options) return;

    if (!options.id) options.id = 'custom-font-options-' + (++nextId);
    if (!trigger.hasAttribute('tabindex')) trigger.tabIndex = 0;
    if (!trigger.hasAttribute('role')) trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-controls', options.id);

    const syncExpanded = () => {
      trigger.setAttribute('aria-expanded', String(!options.classList.contains('hidden')));
    };
    syncExpanded();
    new MutationObserver(syncExpanded).observe(options, { attributes: true, attributeFilter: ['class'] });

    options.querySelectorAll('li[data-value]').forEach(option => {
      if (!option.hasAttribute('tabindex')) option.tabIndex = 0;
      if (!option.hasAttribute('role')) option.setAttribute('role', 'option');
    });
  });
});

document.addEventListener('keydown', event => {
  if (event.defaultPrevented || (event.key !== 'Enter' && event.key !== ' ')) return;
  const target = event.target;
  if (!(target instanceof Element)) return;

  if (target.matches('.custom-font-select .selected-font')) {
    event.preventDefault();
    target.click();
    return;
  }

  if (target.matches('.custom-font-select .font-options li[data-value]')) {
    event.preventDefault();
    target.click();
    target.closest('.custom-font-select')?.querySelector('.selected-font')?.focus();
  }
});
